//系统内置指标样式2：语速时间变化分析
<template>
    <div class="indicator-container">
        <ListHeader title="语速时间变化分析" />
        <div class="indicator-content">
            <div class="score-box">
              <Score :score="data.score" :max-score="data.maxScore"/>
            </div>
            <div class="divider"></div>
            <div class="text-box">

              {{data.remark}}
<!--              教师在整节课中始终围绕“名字里的故事-->
<!--                ”这一核心教学内容，结合教材意图和课-->
<!--                后练习要求，设定了清晰、具体、可操作-->
<!--                的教学目标。例如，在导入阶段-->
<!--                (00:26-05:12)，教师通过引导学生猜测-->
<!--                自己的名字由来，激发学生的表达动机，-->
<!--                并自然过渡到学习如何讲述自己...-->
            </div>
            <div class="divider"></div>
            <div class="chart-box">
                <div id="speedLineChart"></div>
            </div>
        </div>
    </div>
</template>
<script>

import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
export default {
    name: 'SysStyle2',
    components: {
        ListHeader,
        Score,
    },

  props: {
    data: {
      type: Object,
      default: null
    },
  },
    data() {
        return {
            lineChart: null
        };
    },
    mounted() {
        // 确保DOM完全渲染后再初始化图表
        this.$nextTick(() => {
            this.initLineChart();
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        if (this.lineChart) {
            this.lineChart.dispose();
            this.lineChart = null;
        }
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initLineChart() {
            // 获取图表容器
            const chartContainer = document.getElementById('speedLineChart');
            if (chartContainer) {
                // 设置图表容器高度和宽度
                chartContainer.style.width = '100%';
                chartContainer.style.height = '100%';
                // 初始化图表
                this.lineChart = echarts.init(chartContainer);
                // 渲染图表
                this.renderLineChart();
            } else {
                console.error('Chart container not found');
            }
        },
        renderLineChart() {
            // Mock数据 - 语速数据
          const extra=JSON.parse(this.data.extra);

          const mockData={
            time:extra.speech_rate_analysis.chart_data.times,
            speed:extra.speech_rate_analysis.chart_data.wpm_values.map(value => Number(value.toFixed(1))),
          };
          
            // const mockData = {
            //     time: ['00:00', '05:00', '10:00', '15:00', '20:00', '25:00', '30:00', '35:00', '40:00', '45:00', '50:00', '55:00', '60:00'],
            //     speed: [120, 135, 128, 140, 135, 150, 142, 155, 148, 160, 152, 165, 158]
            // };


          const formatTime = (seconds) => {
            // // 将秒转换为mm:ss格式
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
          };
            // 图表配置
            const option = {
                backgroundColor: 'rgba(0, 28, 53, 0.7)',
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0, 28, 53, 0.8)',
                    borderColor: '#0585F7',
                    borderWidth: 1,
                    textStyle: {
                        color: '#FFF'
                    }
                },
                grid: {
                    left: '5%',
                    right: '5%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: mockData.time,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(5, 133, 247, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: '#FFF',
                        fontSize: 10,

                      interval: Math.ceil(mockData.time.length / 5), // 显示约10个标签
                      // 格式化显示时间
                      formatter: function (value) {
                        return formatTime(value);
                      },
                      rotate: 0, // 如果需要可以设置旋转角度
                      margin: 8
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    // max: 200,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(5, 133, 247, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: '#FFF',
                        fontSize: 12,
                        formatter: '{value}字/分钟'
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(5, 133, 247, 0.2)'
                        }
                    }
                },
                series: [
                    {
                        name: '语速',
                        type: 'line',
                        smooth: true, // 开启平滑曲线（贝塞尔曲线）
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: {
                            width: 3,
                            color: '#FDDD60'
                        },
                        itemStyle: {
                            color: '#FDDD60',
                            borderColor: '#FFF',
                            borderWidth: 2
                        },
                        areaStyle: {
                            // 渐变背景色
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(253, 221, 96, 0.5)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(253, 221, 96, 0.1)'
                                }
                            ])
                        },
                        data: mockData.speed
                    }
                ]
            };

            this.lineChart.setOption(option);
        },
        handleResize() {
            if (this.lineChart) {
                this.lineChart.resize();
            }
        }
    }
}
</script>
<style scoped lang="less">
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {

    .indicator-content {

        .text-box {
            flex: 1;
        }

        .chart-box {
            flex: 1;

            #speedLineChart {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
